import { render, staticRenderFns } from "./GerenciadorResultados.vue?vue&type=template&id=443b3474&scoped=true&"
import script from "./GerenciadorResultados.vue?vue&type=script&lang=js&"
export * from "./GerenciadorResultados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443b3474",
  null
  
)

export default component.exports